<template>
  <div class="search-grb">
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">

        <el-form-item :label="`${$t('grb.condition.grb_id')}:`">
          <el-input size="mini" v-model="searchParams.grb_id"></el-input>
        </el-form-item>

        <el-form-item :label="`${$t('grb.condition.obs_from')}:`">
          <el-date-picker
            size="mini"
            v-model="searchParams.obs_from"
            format="yyyy-MM-ddTHH:mm:ss"
            value-format="yyyy-MM-ddTHH:mm:ss"
            type="datetime">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="onSubmit">{{$t('grb.condition.search')}}</el-button>
        </el-form-item>

      </el-form>

      <el-table 
        ref="multipleTable"
        :data="dataList"
        @sort-change="sortChange"
        @selection-change="handleSelectionChange">
        <el-table-column
          fixed
          type="selection"
          :selectable="selectdisable"
          width="55">
        </el-table-column>
        <el-table-column
          prop="grb_id"
          sortable="custom"
          :label="$t('grb.grb_id')">
          <template slot-scope="{row}">
            <span :title="$t('grb.tip.grb_id')">{{row.grb_id}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="trigger_time"
          sortable="custom"
          :label="$t('grb.trigger_time')">
        </el-table-column>
        <el-table-column
          prop="trigger_time_utc"
          :label="$t('grb.trigger_time_utc')">
        </el-table-column>
        <el-table-column
          prop="start_utc"
          sortable="custom"
          :label="$t('grb.start_utc')">
          <template slot-scope="{row}">
            <span :title="$t('grb.tip.start_utc')">{{row.start_utc}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="start_tt"
          :label="$t('grb.start_tt')">
          <template slot-scope="{row}">
            <span :title="$t('grb.tip.start_tt')">{{row.start_tt}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="duration"
          :label="$t('grb.duration')">
          <template slot-scope="{row}">
            <span :title="$t('grb.tip.duration')">{{row.duration}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          :label="$t('grb.status')">
          <template slot-scope="{row}">
            <span :title="$t('grb.tip.status')">{{row.status}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="relate_id"
          :label="$t('grb.relate_id')">
        </el-table-column>
        <el-table-column
          prop="filesize"
          :label="$t('grb.filesize')">
        </el-table-column>
        <el-table-column
          width="150"
          label="操作">
          <template slot="header" >
            <div>
              <!-- //2024年5月24日 变更逻辑,所有公开数据都可以直接下载，不需要申请 -->
              <!-- <el-dropdown @command="handleBulkDownload" v-if="this.userInfo"> -->
              <el-dropdown @command="handleBulkDownload" >  
                <el-button type="primary" size="small" class="op-btn">
                  {{$t('proposal.bulk_down')}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{type: 'bulkdown'}">
                    {{$t('proposal.bulkwebdownload')}}
                  </el-dropdown-item>
                  <el-dropdown-item :command="{type: 'bulkcopy'}">
                    {{$t('proposal.bulkcopy_downlink')}}
                  </el-dropdown-item>
                  <el-dropdown-item :command="{type: 'bulkwget'}">
                    {{$t('proposal.bulkget_wget')}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
          <template slot-scope="scope">
            <el-button
              v-show="scope.row.isApply"
              class="op-btn"
              type="text"
              size="small"
              @click="apply(scope.row)">
              {{$t('proposal.apply')}} 
            </el-button>

            <!-- 下载 -->
            <div v-show="scope.row.isDownload">
              <el-dropdown @command="handleDownload">
                <el-button type="primary" size="small" class="op-btn">
                  {{$t('proposal.download')}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{type: 'download', row: scope.row}">
                    {{$t('proposal.webdownload')}}
                  </el-dropdown-item>
                  <el-dropdown-item :command="{type: 'copy', row: scope.row}">
                    {{$t('proposal.copy_downlink')}}
                  </el-dropdown-item>
                  <el-dropdown-item :command="{type: 'wget', row: scope.row}">
                    {{$t('proposal.get_wget')}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <!-- <el-dropdown  v-show="scope.row.isDownload" size="small" split-button type="primary" :href="`/download/${scope.row.id}`"> 
              {{$t('proposal.download')}}              
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                    <el-button
                      v-show="scope.row.isDownload"
                      :data-clipboard-text="`/download/${scope.row.id}`"
                      type="text"
                      size="small">
                      {{$t('proposal.copy_downlink')}}           
                    </el-button>                  
                </el-dropdown-item>
                <el-dropdown-item>
                    <el-button
                      v-show="scope.row.isDownload"
                      :data-clipboard-text="scope.row.id"
                      type="text"
                      size="small">
                      {{$t('proposal.get_wget')}}            
                    </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->

          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>

      <NoLoginApplyDialog
        :dialog-visible="noLoginApplyIsVisible"
        :dialog-data="currentDataId"
        :dialog-type="tabletype"
        @ok="confirmNoLoginApplyDialog"
        @close="closeNoLoginApplyDialog">
      </NoLoginApplyDialog>

      <LoginApplyDialog
        :dialog-visible="LoginApplyIsVisible"
        :dialog-data="logincurrentDataId"
        :dialog-type="tabletype"
        @ok="confirmLoginApplyDialog"
        @close="closeLoginApplyDialog">
      </LoginApplyDialog>

      <copyTextDialog
        :dialog-visible="copyTextDialogVisible"
        :dialog-data="copyTextDialogData"
        @close="closeCopyTextDialog">
      </copyTextDialog>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import NoLoginApplyDialog from './NoLoginApplyDialog.vue';
import LoginApplyDialog from './LoginApplyDialog.vue';
import copyTextDialog from './copyTextDialog';
export default {
  components: {
    NoLoginApplyDialog,
    LoginApplyDialog,
    copyTextDialog,
  },
  data() {
    return {
      searchParams: {
        grb_id: '',
        obs_from: '',
        obs_to: '',
      },
      list: [],
      currentPage: 1,
      pageSizes:[10,20, 50, 100, 200,300],
      pageSize: 20,
      total: 0,
      noLoginApplyIsVisible: false,
      currentDataId: null,
      tabletype:'',
      LoginApplyIsVisible:false,
      logincurrentDataId:null,
      orderDirection: null,
      orderProp: '',
      copyTextDialogVisible: false,
      copyTextDialogData: '',
      multipleSelection:[],
    };
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapState([
      'userInfo',
    ]),
    userInfo() {
      return this.$store.state.userInfo;
    },
    dataList() {
      return this.list.map((item) => {
        let isDownload = false;
        let isApply = false;
        let isCopyLink = false;
        let isfile = !!item.file_id;
        let isfilename = !!item.filename;

        //2024.10.21 更新逻辑，GRB数据不需要申请，都可以下载，
        // if (this.userInfo) {
        //   isDownload = item.status === 'A' && isfile;
        //   // console.log('登录用户isDownload',isDownload);
        // }else{   
        //   isApply = item.status === 'A' && isfile;    
        //   // isDownload = item.status === 'A' && isfile; 
        //   // console.log('未登录用户isapply',isApply);
        // }
        isDownload = item.status === 'A' && isfile && isfilename;
        return {
          ...item,
          isDownload,
          isApply,
          isCopyLink,
          isfile,
          isfilename,
        }
      });
    },
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchParams,
      };
      if (this.orderDirection && this.orderProp) {
        params.orderDirection = this.orderDirection;
        params.orderProp = this.orderProp;
      }
      axios.post('/iapi/Grb', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }
      });
      // console.log('start',this.searchParams);
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    sizeChange() {
      this.getData();
    },
    closeNoLoginApplyDialog() {
      this.noLoginApplyIsVisible = false;
    },
    closeLoginApplyDialog(){
      this.LoginApplyIsVisible = false;
    },
    confirmNoLoginApplyDialog(data) {
      this.closeNoLoginApplyDialog();
      // console.log('grbdata',data);
      const params = {
        name:data.name,
        id:data.id,
        ogs_id:data.ogs_id,
        remark:data.remark,
        applyemail:data.applyemail,
        applycop:data.applycop,
        data_type:'GRB',
      }
      axios.post('/iapi/apply', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message(this.$t('messinfo.applying'));
        }else if (res.data.errcode === 1) {
          alert('请不要重复申请!(Please do not repeat the application!)');
        }

      });
    },
    confirmLoginApplyDialog(data) {
      this.closeLoginApplyDialog();
      // console.log('grbdata',data);
      const params = {
        name:data.name,
        id:data.id,
        ogs_id:data.ogs_id,
        applyemail:data.applyemail,
        applycop:data.applycop,
        data_type:'GRB',
      }
      axios.post('/iapi/userapply', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message(this.$t('messinfo.applying'));
        }
      });
    },
    sortChange(param) {
      this.orderDirection = param.order;
      this.orderProp = param.prop;
      this.currentPage = 1;
      this.getData();
    },
    apply(dataId) {
      // console.log('dataid',dataId);
      
      if(this.userInfo){
        this.logincurrentDataId = dataId;
        this.LoginApplyIsVisible = true;
      }else{
        this.currentDataId = dataId;
        this.noLoginApplyIsVisible = true;
      }
      this.tabletype = 'GRB';
      
    },
    handleDownload(data) {
      // console.log(data);
      let urls = '';
      if(data.row.isDownload && !(data.type === 'wget')){
        if (this.userInfo){
          urls =  window.location.protocol+'//'+window.location.host+'/iapi/openGrbDownload/'+this.userInfo.umtId+'/GRB/'+data.row.auth_code; 
        }else{
          urls =  window.location.protocol+'//'+window.location.host+'/iapi/openGrbDownload/-1/GRB/'+data.row.auth_code;
        }

      }else if(data.row.isDownload && data.type === 'wget'){
        if (this.userInfo){
          urls =  'wget -c -t 0 -O ' +data.row.filename+' '+window.location.protocol+'//'+window.location.host+'/iapi/openGrbDownload/'+this.userInfo.umtId+'/GRB/'+data.row.auth_code; 
        }else{
          urls =  'wget -c -t 0 -O ' +data.row.filename+' '+window.location.protocol+'//'+window.location.host+'/iapi/openGrbDownload/-1/GRB/'+data.row.auth_code;
        }
      }
      if(urls.length<1){
        alert('请选择要下载的数据产品!(Please select the data product to download)');
        return;
      }
      
    
      if (data.type === 'download') {   
          // window.open(urls);
          let a = document.createElement('a'); // 创建a标签
          let e = document.createEvent('MouseEvents'); // 创建鼠标事件对象
          e.initEvent('click', false, false); // 初始化事件对象
          a.href = urls; // 设置下载地址
          a.download = ''; // 设置下载文件名
          a.dispatchEvent(e);
      }

      if (data.type === 'copy') {
        this.copyTextDialogData = urls;
        this.copyTextDialogVisible = true;
      }

      if (data.type === 'wget') {
        this.copyTextDialogData = urls;
        this.copyTextDialogVisible = true;
      }
    },
    selectdisable(row){
      if(row.isfilename){
        return true;
      }
      return false;
    },
    handleBulkDownload(data){
      if(this.multipleSelection){
        this.multipleSelection.forEach(row =>{
          if(!row.isDownload){
            this.$refs.multipleTable.toggleRowSelection(row,false);
          }
        })
      }
      if(this.multipleSelection.length===0){
        alert('请选择数据!')
        return;
      }
      let urls = [];
      let childurl = '';
      
      this.multipleSelection.forEach((dataitem)=>{
        if(dataitem.isDownload && !(data.type === 'bulkwget')){
          if (this.userInfo){
            childurl =  window.location.protocol+'//'+window.location.host+'/iapi/openGrbDownload/'+this.userInfo.umtId+'/GRB/'+dataitem.auth_code; 
          }else{
            childurl =  window.location.protocol+'//'+window.location.host+'/iapi/openGrbDownload/-1/GRB/'+dataitem.auth_code;
          }

        }else if(dataitem.isDownload && data.type === 'bulkwget'){
          if (this.userInfo){
            childurl =  'wget -c -t 0 -O ' +dataitem.filename+' '+window.location.protocol+'//'+window.location.host+'/iapi/openGrbDownload/'+this.userInfo.umtId+'/GRB/'+dataitem.auth_code; 
          }else{
            childurl =  'wget -c -t 0 -O ' +dataitem.filename+' '+window.location.protocol+'//'+window.location.host+'/iapi/openGrbDownload/-1/GRB/'+dataitem.auth_code;
          }
        }

        // childurl = window.location.protocol+'//'+window.location.host+'/iapi/opendownload/'+this.userInfo.umtId+'/GRB/'+dataitem.auth_code;
        urls = urls.concat(childurl);

      });
      if(urls.length<1){
        alert('请选择要下载的数据产品级别!(Please select the data product level to download !)');
        return;
      }

      if (data.type === 'bulkdown') {
        urls.forEach((item) => {
          // console.log('下载地址',item);
          // window.open(item);
          let a = document.createElement('a'); // 创建a标签
          let e = document.createEvent('MouseEvents'); // 创建鼠标事件对象
          e.initEvent('click', false, false); // 初始化事件对象
          a.href = item; // 设置下载地址
          a.download = ''; // 设置下载文件名
          a.dispatchEvent(e);
        });
      }
      if (data.type === 'bulkcopy') {
        this.copyTextDialogData = urls.join('\r\n');
        this.copyTextDialogVisible = true;
      }

      if (data.type === 'bulkwget') {
        this.copyTextDialogData = urls.join('\r\n');
        // this.copyTextDialogData = urls.map((item) => {
        //   return 'wget ' + item;
        // }).join('\r\n');
        this.copyTextDialogVisible = true;
      }
    },
    handleSelectionChange(val){
      // console.log(val);
      this.multipleSelection = val;
    },
    closeCopyTextDialog() {
      this.copyTextDialogVisible = false;
    },
  },
};
</script>

<style scoped>
.search-grb {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 22px;
}
</style>